import { zodResolver } from '@hookform/resolvers/zod';
import { useSortedCompanies } from 'modules/common';
import { backend } from 'modules/data';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { fieldNameSelectedCompanies, fieldNameWatchType } from './SlackConnectForm.constants';
import { schema } from './SlackConnectForm.schema';
import { SlackConnectFormProps } from './SlackConnectForm.types';

export const useSlackConnectForm = (props: SlackConnectFormProps) => {
    const { onSubmit, onCancel } = props;

    const form = useForm<z.infer<typeof schema>>({
        defaultValues: {
            [fieldNameWatchType]: backend.transfers.CompaniesWatchType.All,
            [fieldNameSelectedCompanies]: [],
        },
        resolver: zodResolver(schema),
    });

    const { resetField, setValue } = form;
    const fieldWatchType = form.watch(fieldNameWatchType);
    const fieldSelectedCompanies = form.watch(fieldNameSelectedCompanies);

    const companies = useSortedCompanies();

    useEffect(() => {
        if (fieldWatchType === backend.transfers.CompaniesWatchType.All && fieldSelectedCompanies.length > 0) {
            resetField(fieldNameSelectedCompanies);
        }
    }, [fieldWatchType, fieldSelectedCompanies.length, resetField]);

    useEffect(() => {
        if (fieldWatchType === backend.transfers.CompaniesWatchType.Selected && companies.length === 1) {
            setValue(fieldNameSelectedCompanies, [companies[0].id]);
        }
    }, [fieldWatchType, companies, setValue]);

    const handleSubmit = form.handleSubmit((data) => {
        onSubmit(data[fieldNameSelectedCompanies]);
    });

    return {
        form,
        companies,
        handleSubmit,
        handleCancel: onCancel,
        isCompaniesVisible: fieldWatchType === backend.transfers.CompaniesWatchType.Selected,
    };
};
